/**
 * BreadcrumbAction
 * 
 * @Author: Focci
 * @Date: 2023-10-31 15:43:58
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-31 15:43:58
 */

'use client'

import PropTypes from 'prop-types'
import useApp from '@hook/useApp'
import dynamic from 'next/dynamic'

const FavoriteAndShare = dynamic(() => import('@page/property/favorite-and-share'), { 
  ssr: false,
  loading: () => <div className="h-6" />
})

export default function BreadcrumbAction({
  house = {}
}) {
  const { isMobile } = useApp()

  if(!isMobile) {
    return <div className="h-6" /> 
  }

  return <FavoriteAndShare house={house} />
}

BreadcrumbAction.propTypes = {
  house: PropTypes.object,
}
